import { useEffect, useState } from 'react';

const useRemainingTime = (expiresAt: number | null) => {
	const [remaining, setRemaining] = useState(() =>
		expiresAt ? Math.max(expiresAt - Date.now(), 0) : 0,
	);

	useEffect(() => {
		if (!expiresAt) {
			setRemaining(0);
			return;
		}

		const updateRemaining = () => {
			setRemaining(Math.max(expiresAt - Date.now(), 0));
		};

		updateRemaining();

		const interval = setInterval(updateRemaining, 1000);

		return () => clearInterval(interval);
	}, [expiresAt]);

	return remaining;
};

export { useRemainingTime };
